module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('crud-input', {
    attrs: {
      "field": _vm.field,
      "options": _vm.options,
      "allow-empty": true,
      "override-type": _vm.options.type === 'reference' || _vm.options.type === 'enum' ? 'references' : _vm.options.type,
      "override-values": _vm.options.type === 'enum' ? _vm.convertEnum(_vm.options.values) : null,
      "filter": true,
      "no-rules": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-999a1018","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Crud/CrudFilter.vue
// module id = 1091
// module chunks = 1